import React, { Suspense } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { PhoneNumber } from "@components/General/PhoneNumber/phoneNumber.component";

type Props = {
    phoneNumber: string;
    country?: string;
    asLink?: string;
};

const PhoneNumberContainer = ({ phoneNumber, country, asLink }: Props) => {
    const { t } = useGranite();

    return (
        <Suspense fallback={<p>{t("common.loading")}</p>}>
            <PhoneNumber
                phoneNumber={phoneNumber}
                asLink={asLink === "true"}
                ISOcountryCode={country}
            />
        </Suspense>
    );
};

export { PhoneNumberContainer };
